import axios from 'axios';
import { api } from '@/api';
import { app } from '@/main';

const types = {
  SET_FAMILIES: 'SET_FAMILIES',
  UPDATE_BABYSITTER: 'UPDATE_BABYSITTER',
  FETCH_FAILURE: 'FETCH_FAILURE',
  SET_LOADING_STATUS: 'SET_LOADING_STATUS',
  SET_FAMILY: 'SET_FAMILY',
  SET_PAYMENT_PLAN: 'SET_PAYMENT_PLAN',
  SET_HAS_NEGATIVE_BALANCE: 'SET_HAS_NEGATIVE_BALANCE',
  SET_WITH_DEACTIVATED: 'SET_WITH_DEACTIVATED',
  SET_CITY: 'SET_CITY',
  SET_POTENTIAL_FAMILY: 'SET_POTENTIAL_FAMILY',
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  SET_ITEMS_PER_PAGE: 'SET_ITEMS_PER_PAGE',
  SET_TOTAL_ITEMS: 'SET_TOTAL_ITEMS',
};

export const state = {
  families: [],
  loading: false,

  // filters
  family: null,
  paymentPlan: null,
  hasNegativeBalance: null,
  withDeactivated: null,
  city: null,
  potential_family: false,
  currentPage: 1,
  itemsPerPage: 10,
  total: null,
};

export const mutations = {
  [types.SET_FAMILIES](state: any, data: any) {
    state.families = [];

    state.families.push(...data.data);
    state.total = data.meta.total ? data.meta.total : 1;
  },
  [types.SET_LOADING_STATUS](state: any, bool: boolean) {
    state.loading = bool;
  },

  [types.SET_FAMILY](state: any, data: string) {
    state.family = data;
  },
  [types.SET_PAYMENT_PLAN](state: any, data: number) {
    state.paymentPlan = data;
  },
  [types.SET_HAS_NEGATIVE_BALANCE](state: any, data: number) {
    state.hasNegativeBalance = data;
  },
  [types.SET_WITH_DEACTIVATED](state: any, data: number) {
    state.withDeactivated = data;
  },
  [types.SET_CITY](state: any, data: string) {
    state.city = data;
  },

  [types.SET_CURRENT_PAGE](state: any, data: number) {
    state.currentPage = data;
  },

  [types.SET_ITEMS_PER_PAGE](state: any, data: number) {
    state.itemsPerPage = data;
  },
  [types.SET_POTENTIAL_FAMILY](state: any, data: number) {
    state.potential_family = data;
  },
};

export const actions = {
  async fetchFamilies({ commit, getters }: any, params: any) {
    try {
      commit(types.SET_LOADING_STATUS, true);
      let params = getters.payload;

      const { data } = await axios.get(api.path('v1.admin.families'), {
        params: params,
      });

      commit(types.SET_FAMILIES, data);
      commit(types.SET_LOADING_STATUS, false);
    } catch (e) {
      commit(types.FETCH_FAILURE);
      commit(types.SET_LOADING_STATUS, false);
    }
  },

  clearPayload({ commit }: any, payload: any) {
    commit(types.SET_FAMILY, null);
    commit(types.SET_PAYMENT_PLAN, null);
    commit(types.SET_HAS_NEGATIVE_BALANCE, null);
    commit(types.SET_WITH_DEACTIVATED, null);
    commit(types.SET_CITY, null);
    commit(types.SET_POTENTIAL_FAMILY, null);
    commit(types.SET_CURRENT_PAGE, 1);
    commit(types.SET_ITEMS_PER_PAGE, 10);
  },

  setFamilies({ commit }: any, payload: any) {
    commit(types.SET_FAMILIES, payload);
  },
  setFamiliesLoading({ commit }: any, payload: any) {
    commit(types.SET_LOADING_STATUS, payload);
  },

  setFamily({ commit }: any, payload: any) {
    commit(types.SET_FAMILY, payload);
  },
  setPaymentPlan({ commit }: any, payload: any) {
    commit(types.SET_PAYMENT_PLAN, payload);
  },
  setHasNegativeBalance({ commit }: any, payload: any) {
    commit(types.SET_HAS_NEGATIVE_BALANCE, payload);
  },
  setWithDeactivated({ commit }: any, payload: any) {
    commit(types.SET_WITH_DEACTIVATED, payload);
  },
  setCity({ commit }: any, payload: any) {
    commit(types.SET_CITY, payload);
  },
  setIsPotentialFamily({ commit }: any, payload: any) {
    commit(types.SET_POTENTIAL_FAMILY, payload);
  },
  setCurrentPage({ commit }: any, payload: any) {
    commit(types.SET_CURRENT_PAGE, payload);
  },
  setItemsPerPage({ commit }: any, payload: any) {
    commit(types.SET_ITEMS_PER_PAGE, payload);
  },
};

export const getters = {
  families: (state: any) => state.families,
  familiesLoading: (state: any) => state.loading,
  total: (state: any) => state.total,

  family: (state: any) => state.family,
  paymentPlan: (state: any) => state.paymentPlan,
  hasNegativeBalance: (state: any) => state.hasNegativeBalance,
  withDeactivated: (state: any) => state.withDeactivated,
  city: (state: any) => state.city,
  isPotentialFamily: (state: any) => state.potential_family,
  currentPage: (state: any) => state.currentPage,
  itemsPerPage: (state: any) => state.itemsPerPage,

  payload: (state: any) => {
    return {
      family: state.family,
      plan: state.paymentPlan,
      has_negative_balance: state.hasNegativeBalance
        ? state.hasNegativeBalance
        : null,
      with_deactivated: state.withDeactivated ? state.withDeactivated : null,
      city: state.city,
      page: state.currentPage,
      per_page: state.itemsPerPage,
      potential_family: state.potential_family,
    };
  },
};
